import React, { Component } from 'react';
import { connect } from 'react-redux';
import $ from 'jquery';
import limparUltimosHistoricosPassageiro from '../../actions/pedido/limparUltimosHistoricosPassageiro';

import Moment from 'react-moment';
import capitalizarTodasPrimeirasLetras from '../../util/capitalizarTodasPrimeirasLetras';

export const Cabecalho = () => (
    <thead>
      <tr>
        <th className="vx-hist-th">Data e Hora</th>
        <th className="vx-hist-th">Situação</th>
        <th className="vx-hist-th">Usuário</th>
        <th className="vx-hist-th">CPF</th>
        <th className="vx-hist-th">Nome</th>
        <th className="vx-hist-th">Nascimento</th>
        <th className="vx-hist-th">Doc. Foto</th>
        <th className="vx-hist-th">Telefone</th>
      </tr>
    </thead>
  );

export class ModalHistoricoPassageiro extends Component {

    fecharModal () {
        $('#modalHistoricoPassageiro')
            .modal('hide');
        $('#modalHistoricoPassageiro')
            .hide();
        $('.modal-backdrop')
            .hide();        
        this.props.limparUltimosHistoricosPassageiro();        
    }

    exibirHistoricos() {
        if (this.props.historicos && this.props.historicos.length) {
            return this.props.historicos.map(historico => (
              <div key={`reserva-${historico.reservaId}`} className="vx-modal-section" style={{marginBottom: 14}}>
                <div className="vx-hist-reserva-badge">
                  <span className="material-icons">confirmation_number</span>
                  Reserva #{historico.reservaId}
                </div>
                <div className="vx-hist-wrap">
                  <table className="vx-hist-table">
                    <Cabecalho />
                    <tbody>
                      {historico.historicosPassageiro.map(hp => (
                        <tr key={hp.id}>
                          <td className="vx-hist-td"><Moment format="DD/MM/YYYY HH:mm">{hp.dataEvento}</Moment></td>
                          <td className="vx-hist-td"><span className="vx-hist-badge">{capitalizarTodasPrimeirasLetras(hp.tipoEvento)}</span></td>
                          <td className="vx-hist-td">{capitalizarTodasPrimeirasLetras(hp.responsavel.nome)}</td>
                          <td className="vx-hist-td">{hp.passageiro.cpf}</td>
                          <td className="vx-hist-td">{capitalizarTodasPrimeirasLetras(hp.passageiro.nome)}</td>
                          <td className="vx-hist-td">{hp.passageiro.dtNascimento || '-'}</td>
                          <td className="vx-hist-td">{hp.passageiro.documentoComFoto || '-'}</td>
                          <td className="vx-hist-td">{hp.passageiro.ddi || ''} {hp.passageiro.telefone || '-'}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                {historico.historicosCrianca && historico.historicosCrianca.length > 0 && (
                  <React.Fragment>
                    <div className="vx-hist-section-title" style={{marginTop: 14}}>
                      <span className="material-icons">child_care</span>
                      Histórico Criança de Colo
                    </div>
                    <div className="vx-hist-wrap">
                      <table className="vx-hist-table">
                        <Cabecalho />
                        <tbody>
                          {historico.historicosCrianca.map(hc => (
                            <tr key={hc.id}>
                              <td className="vx-hist-td"><Moment format="DD/MM/YYYY HH:mm">{hc.dataEvento}</Moment></td>
                              <td className="vx-hist-td"><span className="vx-hist-badge">{capitalizarTodasPrimeirasLetras(hc.tipoEvento)}</span></td>
                              <td className="vx-hist-td">{capitalizarTodasPrimeirasLetras(hc.responsavel.nome)}</td>
                              <td className="vx-hist-td">{hc.crianca.cpfCrianca}</td>
                              <td className="vx-hist-td">{capitalizarTodasPrimeirasLetras(hc.crianca.nome)}</td>
                              <td className="vx-hist-td">{hc.crianca.dtNascimentoCrianca || '-'}</td>
                              <td className="vx-hist-td">{hc.crianca.documentoCriacaComFoto || '-'}</td>
                              <td className="vx-hist-td">-</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </React.Fragment>
                )}
              </div>
            ))
        }
        return (
          <div style={{textAlign: 'center', padding: '40px 20px', color: '#999'}}>
            <span className="material-icons" style={{fontSize: 40, display: 'block', marginBottom: 8}}>person_off</span>
            Nenhum histórico encontrado
          </div>
        )
    }

    render() {
        const pedidoId = this.props.historicos && this.props.historicos.length
          ? this.props.historicos[0].pedidoId : '';
        return (
          <div className="modal fade show" id='modalHistoricoPassageiro' role='dialog'
               aria-labelledby='modalHistoricoPassageiro' aria-hidden='true' data-backdrop='static'>
            <div className="modal-dialog modal-dialog-centered modal-xl">
              <div className="modal-content" style={{borderRadius: '12px', overflow: 'hidden', border: 'none'}}>

                <div className="vx-modal-header">
                  <div className="vx-modal-title">
                    <span className="material-icons">person</span>
                    Histórico de Passageiros
                    {pedidoId ? <span style={{fontWeight: 400, fontSize: '13px', opacity: .7}}> — Pedido #{pedidoId}</span> : ''}
                  </div>
                  <button type="button" className="vx-modal-close" data-dismiss="modal"
                          aria-label="Fechar" onClick={() => this.fecharModal()}>
                    <span className="material-icons">close</span>
                  </button>
                </div>

                <div className="vx-modal-body">
                  {this.exibirHistoricos()}
                </div>

                <div className="vx-modal-footer">
                  <button type="button" className="vx-modal-btn-fechar" data-dismiss="modal"
                          onClick={() => this.fecharModal()}>
                    Fechar
                  </button>
                </div>

              </div>
            </div>
          </div>
        )
    }
}

export const mapStateToProps = (state) => {
    return {        
        empresaSelecionada: state.empresaSelecionada,        
        historicos: state.ultimosHistoricosPassageiro,
        pedido: state.pedido
    }
};

export default connect(mapStateToProps, {    
    limparUltimosHistoricosPassageiro
})(ModalHistoricoPassageiro)